
export { IS_PROD } from "/vercel/path0/libs/constants/src/lib/environments.ts"